import styled from "styled-components";

export const Page = styled.div`
  height: 100%;
  overflow: auto;
  background: #eef2f6;
  color: #1f2937;
  font-family: var(--font-body);
  font-size: var(--app-font-size, 13px);
`;

export const Wrapper = styled.div`
  max-width: 1460px;
  margin: 0 auto;
  padding: 16px 10px 24px;
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 240px;
  gap: 10px;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #f7f7f7;
  border: 1px solid #d5dde6;
  border-radius: 8px;
  padding: 18px 16px 16px;
  font-size: var(--app-font-size, 13px);
`;

export const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  margin: 0;
  color: #123e73;
  font-family: var(--font-display);
  font-size: calc(var(--app-font-size, 13px) * 1.35);
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;

export const TitleRule = styled.div`
  height: 3px;
  background: #2f86de;
  margin: 10px 0 18px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 12px 14px;
`;

export const Field = styled.div`
  grid-column: span ${({ $span = 12 }) => $span};
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: var(--app-font-size, 13px);

  @media (max-width: 1024px) {
    grid-column: span 12;
  }
`;

export const Label = styled.label`
  font-family: var(--font-body);
  font-size: calc(var(--app-font-size, 13px) * 0.95);
  font-weight: 600;
  color: #334155;
  line-height: 1.15;
`;

const sharedInput = `
  width: 100%;
  min-height: 32px;
  height: max(32px, calc(var(--app-font-size, 13px) * 2.3));
  border: 1px solid #c8d1db;
  border-radius: 5px;
  padding: 5px 10px;
  font-family: var(--font-body);
  font-size: var(--app-font-size, 13px);
  color: #253244;
  background: #ffffff;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    border-color: #2f86de;
    box-shadow: 0 0 0 2px rgba(47, 134, 222, 0.14);
  }

  &:disabled,
  &[readonly] {
    background: #ffffff;
    color: #253244;
  }
`;

export const Input = styled.input`
  ${sharedInput}
`;

export const Select = styled.select`
  ${sharedInput}
  padding-right: 28px;
`;

export const InfoBox = styled.div`
  ${sharedInput}
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const AsideTitle = styled.h3`
  margin: 0 0 10px;
  color: #123e73;
  font-family: var(--font-display);
  font-size: calc(var(--app-font-size, 13px) * 1.15);
  font-weight: 700;
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HistoryItem = styled.button`
  width: 100%;
  text-align: left;
  border: 1px solid #d4dde8;
  background: #ffffff;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  font-family: var(--font-body);
  font-size: var(--app-font-size, 13px);

  &:hover {
    border-color: #7aaee5;
    background: #f8fbff;
  }

  strong {
    font-size: var(--app-font-size, 13px);
  }
`;

export const HistoryMeta = styled.div`
  margin-top: 3px;
  font-family: var(--font-body);
  font-size: calc(var(--app-font-size, 13px) * 0.9);
  color: #56677a;
`;

export const EmptyText = styled.p`
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--app-font-size, 13px);
  color: #6b7a8c;
  line-height: 1.4;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  padding-top: 12px;
  margin-top: 4px;
  border-top: 1px solid #d5dde6;
`;

export const LoadingText = styled.p`
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--app-font-size, 13px);
  color: #6b7a8c;
`;
